import { ILogger } from '@cian/logger';
import { UnknownError } from '@cian/peperrors';
import * as React from 'react';

import { EExceptionDomain } from '../../types/exceptionDomains';
import { ETelemetryEvents, TAppTelemetryLogger } from '../../types/telemetry';
import { ChatsErrorPage } from '../ChatsErrorPage';

interface ILoadableErrorBoundaryProps {
  telemetry: TAppTelemetryLogger;
  logger: ILogger;
  children: React.ReactNode;
}

interface ILoadableErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<ILoadableErrorBoundaryProps, ILoadableErrorBoundaryState> {
  public state: ILoadableErrorBoundaryState = {
    hasError: false,
  };

  public static getDerivedStateFromError(): ILoadableErrorBoundaryState {
    return {
      hasError: true,
    };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    const { telemetry, logger } = this.props;

    if (telemetry) {
      telemetry.increment(ETelemetryEvents.ChatPageCrashFail);
    }

    if (logger) {
      const errorToLog = new UnknownError({
        domain: EExceptionDomain.Common,
        message: 'Ошибка рендеринга компонента',
        details: error,
      });

      logger.error(errorToLog, { info: JSON.stringify(info) });
    }
  }

  public render() {
    if (this.state.hasError) {
      return <ChatsErrorPage onRetry={this.handleRetryClick} />;
    }

    return this.props.children;
  }

  private handleRetryClick = () => {
    window.location.reload();

    this.setState({
      hasError: false,
    });
  };
}
